import React, {useContext} from "react"

// context & data
import {CatalogueContext} from "../../../context/CatalogueContext"
import data from "../../../data"

// components
import {Link, CopyToClipboard, SurpriseLink, TicketLink, ExternalLink} from "../../controls"
import Stars from "../../controls/Stars"
import {Block, HtmlHeader, Scaffolding} from "../../shared"

// styling & images
import "./Done.scss"
import Images from "../../../images";

function Done() {
  // context
  const catalogue = useContext(CatalogueContext)

  // render loading screen if data is still loading
  if(!catalogue.isReady) {
    return null
  }

  // get purchases stored in local storage
  let purchases = data.Cart.getPurchases().sort((a,b) => {
    return (new Date(a.date)) > (new Date(b.date)) ? -1 : 1
  })

  // no recent purchase?
  if(purchases.length === 0) {
    return (
      <Scaffolding>
        <Block>
          <div id="v-done" className="content-container">
            <h1>Keine Bestellungen gefunden</h1>
            <p>
              <Link to="/" className="button secondary">Zurück zum Appentura Shop</Link>
            </p>
          </div>
        </Block>
      </Scaffolding>
    )
  }

  let purchase = null
  if(purchases.length > 0) {
    purchase = purchases[0]
  }

  let ticketLink = null
  let clipboard = <CopyToClipboard value={purchase.shortUrl}>Link zur Überraschung in die Zwischenablage kopieren</CopyToClipboard>
  let download = <p><TicketLink id={purchase.id}>Gutschein herunterladen</TicketLink></p>
  
  // TODO the shipping types now tell us what kind they are ... so it is not necessary to hardcode this
  if(purchase.shippingCode === "PDF" || purchase.shippingCode === "PDF_DE") {
    ticketLink = <>
      {download}
    </>
  }
  else if(purchase.shippingCode === "VIRTUAL" || purchase.shippingCode === "VIRTUAL_DE") {
    ticketLink = (
      <>
        <SurpriseLink shortUrl={purchase.shortUrl} receiverName={purchase.receiverName} />
        
        <p>oder</p>
        {clipboard}
      </>
    )
  }

  let otherPurchases = null
  if(purchases.length > 1) {
    let rows = purchases
      .filter((item, index) => index > 0)
      .map(item => {
        let date = new Date(item.date)
        return (
          <tr key={item.id}>
            <td>{date.toLocaleDateString("de-DE", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</td>
            <td>für {item.receiverName}</td>
            <td><TicketLink id={item.id}>Gutschein herunterladen</TicketLink></td>
          </tr>
        )
      })
    otherPurchases = (
      <>
        <h2>Frühere Bestellungen von Dir</h2>
        <table><tbody>
          {rows}
        </tbody></table>
      </>
    )
  }

  let joy = 'Die Freude bei der beschenkten Person wird sicher riesig sein.'
  if(purchase.receiverName && purchase.receiverName.trim().length > 0) {
    joy = `Die Freude bei ${purchase.receiverName} wird sicher riesig sein.`
  }
  
  console.log(purchase)
  return (
    <Scaffolding>
      <Block>
        <HtmlHeader title="Appentura - Einkauf abgeschlossen" />
        <div id="v-done" className="content-container">
          <h1>{`Hei ${purchase.reserverName || "Du"}, ein grosses Merci für deine Bestellung!`}</h1>

          <GoogleReview purchase={purchase} />

          <p>Eine Mail-Bestätigung erhältst Du bereits in den nächsten Minuten.</p>
          {ticketLink}
          <p>{joy} Wir wünschen viel Spass beim Schenken!</p>
          <p>
            <Link to="/" className="button secondary">Zurück zum Appentura Shop</Link>
          </p>
          
          {otherPurchases}
        </div>
      </Block>
    </Scaffolding>
  )
}

function GoogleReview({purchase}) {
  const googleReviewLink = "https://search.google.com/local/writereview?placeid=ChIJ_4B0IZY5jkcRffKFwHprRaU";
  return (
    <div className="google-review">
      <div className="text">
        Deine Entscheidung für ein Appentura-Geschenk war genau richtig. Bewerte Appentura jetzt bei Google, um zukünftigen Kunden bei der Auswahl zu helfen.
      </div>
      <div className="link-logo">
        <ExternalLink to={googleReviewLink} target="_blank">
          <div className="link-logo-image">
            <img alt="google review" src={Images.logos.googleReview} />
          </div>
        </ExternalLink>
      </div>
      <div className="link-text">
        <ExternalLink to={googleReviewLink} target="_blank">Hier kommst du zu Google-Rezensionen.</ExternalLink>
      </div>
    </div>
  ) 
}
export default Done

